import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles(theme => ({
  root: {
    height: 55,
    "&:hover": {
      backgroundColor: "transparent",
      "& p": {
        color: theme.palette.primary.brandPrimary,
        textTransform: "unset",
      },
    },
  },

  active: {
    backgroundColor: theme.palette.secondary.light,
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(2),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  title: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.6rem",
    lineHeight: "1.7rem",
  },

  deleted: {
    color: theme.palette.error.main,
  },

  subtitle: {
    fontSize: ".9rem",
  },
}));

const AddMediaToParentMenuItem = props => {
  const {
    active,
    dataIndex,
    parent,
    checked,
    handleClick,
    onClick,
    forAutocomplete,
  } = props;
  const classes = useStyles();

  return forAutocomplete ? (
    <Fragment>
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={parent.name}
          src={`${parent.thumbnailUrl}&tc${Date.now()}`}
          className={classes.thumbnail}
        />
      </ListItemAvatar>
      <Tooltip title={parent.title || parent.name}>
        <ListItemText>
          <div className={classes.main}>
            <Typography
              classes={{
                root: clsx(classes.title, {
                  [classes.deleted]: parent.status === "DELETED",
                }),
              }}
              noWrap
            >
              {parent.title || parent.name}
            </Typography>
          </div>
        </ListItemText>
      </Tooltip>
      <ListItemSecondaryAction>
        <Checkbox
          color="primary"
          checked={checked}
          disabled={parent.status === "DELETED"}
          onChange={handleClick}
          inputProps={{ "aria-labelledby": parent.id }}
        />
      </ListItemSecondaryAction>
    </Fragment>
  ) : (
    <MenuItem
      data-index={dataIndex}
      classes={{
        root: clsx(classes.root, {
          [classes.active]: active,
        }),
      }}
      tabIndex={active ? 0 : -1}
      onClick={event => onClick(event, parent.id)}
    >
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={parent.name}
          src={`${parent.thumbnailUrl}&tc${Date.now()}`}
          className={classes.thumbnail}
        />
      </ListItemAvatar>
      <Tooltip title={parent.title || parent.name}>
        <ListItemText>
          <div className={classes.main}>
            <Typography classes={{ root: classes.title }} noWrap>
              {parent.title || parent.name}
            </Typography>
          </div>
        </ListItemText>
      </Tooltip>
      <ListItemSecondaryAction>
        <Checkbox
          color="primary"
          checked={checked}
          onChange={event => onClick(event, parent.id)}
          inputProps={{ "aria-labelledby": parent.id }}
        />
      </ListItemSecondaryAction>
    </MenuItem>
  );
};

export default AddMediaToParentMenuItem;
